import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAgent, IGetAgentNotesResponse } from "../../api/agents/index.types";

export interface IAgentState {
  data: IAgent & {
    admin_accounts_notes: IGetAgentNotesResponse["data"];
  };
  loading: boolean;
}
export const initialState: IAgentState = {
  data: {
    email: "",
    id: 0,
    name: "",
    allowed_features: {} as Record<string, boolean>,
    active: false,
    preset: "",
    profile_photo: null,
    position: null,
    shift: null,
    start_date: null,
    used_vacation_allowance: 0,
    admin_accounts_notes: {
      count: 0,
      rows: [],
      active_notes: 0,
      loading: false,
    },
    admin_accounts_policies_preset: {
      name: "",
      name_preset: "",
    },
  },
  loading: false,
};

const index = createSlice({
  name: "agent",
  initialState,
  reducers: {
    // Fetch Agent
    fetchAgentRequest(state) {
      state.loading = true;
    },
    fetchAgentSuccess(state, action: PayloadAction<IAgent>) {
      state.loading = false;
      state.data = { ...state.data, ...action.payload };
    },
    fetchAgentFailed(state) {
      state.loading = false;
    },
    // Fetch Agent Notes
    fetchAgentNotesRequest(state) {
      state.data.admin_accounts_notes.loading = true;
    },
    fetchAgentNotesSuccess(state, action: PayloadAction<IGetAgentNotesResponse>) {
      state.data.admin_accounts_notes = action.payload.data;
    },
    fetchAgentNotesFailed(state) {
      state.data.admin_accounts_notes.loading = false;
    },
  },
});

export const agentActions = index.actions;
export default index.reducer;
